export default import.meta.ROLLDOWN_FILE_URL_zOyQqdNGsn0lL_XEFrarVA